import Accordion from 'react-bootstrap/Accordion';
import Competitor from 'components/presentation/Competitor';
import Noc from 'components/presentation/Noc';
import SportCode from 'components/common/SportCode'
import NotAvailable from 'components/common/NotAvailable';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { useViewport } from 'components/general/useViewPort'

function TenPbp({ data, periodsOrder }) {
  return <Pbp data={data} config={{ periodsOrder: periodsOrder }} />
}

export default TenPbp;

const Pbp = ({ data, config }) => {
  const { mirs_rsc } = useUrlFriendlyToParameters()
  return (
    <div className="pbp-main" id={`mirs-accordion-play-by-play-${mirs_rsc}`}>
      <RenderAccordion data={data} config={config} />
    </div>
  )
}

const RenderAccordion = ({ data, config }) => {
  let out = (<NotAvailable />)

  if (data?.results?.playByPlay?.length > 0) {
    let periods = data.results.playByPlay;
    periods?.sort((a, b) => getPeriodOrder(config?.periodsOrder, b.subcode) - getPeriodOrder(config?.periodsOrder, a.subcode));
    out = (
      <Accordion defaultActiveKey={periods[0].subcode}>
        <RenderPeriods periods={periods} home={data.results.home} away={data.results.away} />
      </Accordion>
    )
  }
  return out;
}

const getPeriodOrder = (periodsOrder, period) => {
  return periodsOrder?.find(i => i.period === period)?.order;
}

const RenderPeriods = ({ periods, home, away }) => {
  const { mirs_discipline } = useUrlFriendlyToParameters()
  return periods?.map(item => {
    return (
      <Accordion.Item id={`mirs-accordion-item-${item.subcode}`} eventKey={item.subcode} key={item.subcode}>
        <Accordion.Header><SportCode discipline={mirs_discipline} entity='@Period' code={item.subcode} /></Accordion.Header>
        <Accordion.Body>
          {/* <RenderHeader home={home} away={away} /> */}
          <RenderSinglePeriod actions={item.actions} subcode={item.subcode} home={home} away={away} />
        </Accordion.Body>
      </Accordion.Item>
    )
  }
  )
}

const RenderSinglePeriod = ({ actions, subcode, home, away }) => {
  let games = []


  if (actions) {
    actions.forEach(a => {
      let game = games.find(g => g.game === a.pbpa_Action);
      if (a.pbpa_Action && game) game.actions.push(a);
      if (a.pbpa_Action && !game) games.push({ game: a.pbpa_Action, actions: [a] })
    });
  }
  return <RenderGames games={games} subcode={subcode} home={home} away={away} />
}

const RenderGames = ({ games, subcode, home, away }) => {
  const { mirs_discipline } = useUrlFriendlyToParameters()
  //console.log(games)
  let currentGame = games && Array.isArray(games) && games.length > 0 ? games[0].game : '';
  const accordionItems = (games?.map(game => {
    return (
      <Accordion.Item id={`mirs-accordion-item-${subcode}-${game.game}`} eventKey={`${subcode}-${game.game}`} key={`${subcode}-${game.game}`}>
        <Accordion.Header>
          <div className='w-100'>
            <div><SportCode discipline={mirs_discipline} entity='@Action' code={game?.game} /></div>
            <div><RenderHeader home={home} away={away} game={game} subcode={subcode} currentGame={currentGame} /></div>
          </div>
        </Accordion.Header>
        <Accordion.Body>
          <RenderSingleGame actions={game.actions} home={home} away={away} />
        </Accordion.Body>
      </Accordion.Item>
    )
  })
  )
  return (
    <Accordion defaultActiveKey={`${subcode}-${games[0].game}`}>
      {accordionItems}
    </Accordion>
  )
}

const RenderSingleGame = ({ actions, home, away }) => {
  return actions?.map(item => {
    return <RenderAction action={item} home={home} away={away} key={item.pbpa_id} />
  })
}

const RenderAction = ({ action, home, away }) => {
  const { mirs_discipline } = useUrlFriendlyToParameters();
  const { breakPoint } = useViewport();

  let ptType = action?.extendedActions?.find(exta => exta?.pbpea_code === 'PT_TYPE')?.pbpea_value
  ptType = ptType && <SportCode discipline={mirs_discipline} entity='@PtType' code={ptType} />
  ptType = ptType && (<>
    <div className="row" key={action.pbpa_id}>
      <div className="col-5 "></div>
      <div className="col-2"><CenterRender action={action} home={home} away={away} showPtType={true} /></div>
      <div className="col-5 "></div>
    </div>
  </>)
  let ptTypeSm = ptType && (<>
    <div className="row" key={action.pbpa_id}>
      <div className="col-3"><CenterRender action={action} home={home} away={away} showPtType={true} /></div>
      <div className="col-9 "></div>
    </div>
  </>)
  const pointsCenterXl = (<>
    <div className="row" key={action.pbpa_id}>
      <div className="col-5 "><SideRender action={action} homeAway={home} home={home} away={away} /></div>
      <div className="col-2"><CenterRender action={action} home={home} away={away} showPtType={false} /></div>
      <div className="col-5 "><SideRender action={action} homeAway={away} home={home} away={away} /></div>
    </div>
    {ptType}
  </>)

  const pointsCenterSm = (<>
    <div className="row" key={action.pbpa_id}>
      <div className="col-3"><CenterRender action={action} home={home} away={away} showPtType={false} /></div>
      <div className="col-9 ">
        <SideRender action={action} homeAway={home} home={home} away={away} />
        <SideRender action={action} homeAway={away} home={home} away={away} />
      </div>
    </div>
    {ptTypeSm}


  </>)

  return breakPoint === "sm" || breakPoint === "xs" ? pointsCenterSm : pointsCenterXl;
}


const SideRender = ({ action, homeAway }) => {
  const { mirs_discipline } = useUrlFriendlyToParameters();
  const { breakPoint } = useViewport();
  const comp = action?.competitors?.find(item => item.pbpc_code === homeAway.participant?.code)

  if (!comp) return; //do nothing if there is no competitor related to the action

  return (

    <div className="box">
      {(breakPoint === "sm" || breakPoint === "xs") &&
        <><Competitor hidePicture={true} alwaysNoc={true} {...homeAway?.participant} />&nbsp;</>}
      <div>
        {/*<SportCode discipline={mirs_discipline} entity='@ResAction' code={action?.pbpa_Result} />&nbsp;{action?.pbpa_Result}*/}
        <SportCode discipline={mirs_discipline} entity='@ActionDesc' code={action?.pbpa_ActionDesc} />&nbsp;

      </div>
    </div>
  )
}

const CenterRender = ({ action, home, away, showPtType }) => {
  let [a, b, c] = ['', '', ''];
  const { mirs_discipline } = useUrlFriendlyToParameters()
  let isHome = false
  let isAway = false
  let showBall = false
  const ball = <FontAwesomeIcon icon={faCircle} />
  if (action?.pbpa_Action === 'TB') {
    showBall = true
    let server = action?.extendedActions?.find(i => i?.pbpea_code === 'SERVER')?.pbpea_value;
    if (home?.teamAthletes && Array.isArray(home?.teamAthletes)) {
      isHome = showBall && home?.teamAthletes?.find(i => i?.athlete?.code === server) ? true : false
    } else {
      isHome = showBall && home?.participant?.code === server ? true : false
    }
    isAway = showBall && !isHome

  }
  if (action.competitors === undefined) a = (<div>{`${action?.pbpa_ActionDesc}  (${action?.pbpa_Action})`}</div>);

  if (action?.pbpa_When) b = (<div>{action?.pbpa_When}</div>);

  if (action.pbpa_ScoreH) c = (<div className='fw-bolder'>{isHome ? ball : ''}&nbsp;{action?.pbpa_ScoreH} - {action?.pbpa_ScoreA}&nbsp;{isAway ? ball : ''}</div>);

  let ptType = action?.extendedActions?.find(exta => exta?.pbpea_code === 'PT_TYPE')?.pbpea_value
  ptType = ptType && <SportCode discipline={mirs_discipline} entity='@PtType' code={ptType} />

  return (<>
    {showPtType
      ? <div className='box-center box-center-dark text-center'><strong>{ptType}</strong></div>
      : <div className='box-center text-center'><strong>{a}{b}{c}</strong></div>
    }
  </>);
}

const RenderHeader = ({ home, away, game, subcode, currentGame }) => {

  const { breakPoint } = useViewport();
  if (breakPoint === "sm" || breakPoint === "xs") {
    return ''
  }
  let homeScore = ''
  let awayScore = ''
  let server = ''
  const resultObjHome = home?.resultDataText ? JSON.parse(home?.resultDataText) : {};
  const resultObjAway = away?.resultDataText ? JSON.parse(away?.resultDataText) : {};

  game?.actions?.forEach(act => {
    //act?.extendedActions?.find(exta => exta?.pbpea_code === 'SET_SCORE_H'))?.pbpea_value;
    let homeScore_ = act?.extendedActions?.find(exta => exta?.pbpea_code === 'SET_SCORE_H')?.pbpea_value
    let awayScore_ = act?.extendedActions?.find(exta => exta?.pbpea_code === 'SET_SCORE_A')?.pbpea_value
    let server_ = act?.extendedActions?.find(exta => exta?.pbpea_code === 'SERVER')?.pbpea_value
    //let ptType = act?.extendedActions?.find(exta => exta?.pbpea_code === 'PT_TYPE')?.pbpea_value


    if (homeScore_) {
      server = server_;
      homeScore = homeScore_;
    }
    if (awayScore_) awayScore = awayScore_;

  })

  let gamesHome = resultObjHome?.extra?.resultS1
  let gamesAway = resultObjAway.extra?.resultS1

  gamesHome = homeScore
  gamesAway = awayScore

  let currentPeriod = resultObjHome?.extra?.currentPeriod
  //let currentScoreHome = currentPeriod === 'S1' ? gamesHome : currentPeriod === 'S2' ? gamesHome : currentPeriod === 'S3' ? gamesHome : '';
  //let currentScoreAway = currentPeriod === 'S1' ? gamesAway : currentPeriod === 'S2' ? gamesAway : currentPeriod === 'S3' ? gamesAway : '';
  //subcode , currentGame

  let isCurrent = subcode === currentPeriod;
  let isHomeCurrent = isCurrent && resultObjHome?.extra?.current === "true"
  let isAwayCurrent = isCurrent && !isHomeCurrent

  isHomeCurrent = server === home?.participant?.code
  isAwayCurrent = !isHomeCurrent

  //console.log(currentGame)
  gamesHome === '' && subcode === 'S3'
    ? gamesHome = resultObjHome?.extra?.resultS3
    : gamesHome = gamesHome
  gamesHome === '' && subcode === 'S2'
    ? gamesHome = resultObjHome?.extra?.resultS2
    : gamesHome = gamesHome
  gamesHome === '' && subcode === 'S1'
    ? gamesHome = resultObjHome?.extra?.resultS1
    : gamesHome = gamesHome

  gamesAway === '' && subcode === 'S3'
    ? gamesAway = resultObjAway?.extra?.resultS3
    : gamesAway = gamesAway
  gamesAway === '' && subcode === 'S2'
    ? gamesAway = resultObjAway?.extra?.resultS2
    : gamesAway = gamesAway
  gamesAway === '' && subcode === 'S1'
    ? gamesAway = resultObjAway?.extra?.resultS1
    : gamesAway = gamesAway


  return (
    <><div className="row">
      <div className="col-5">
        <div className='d-flex justify-content-end'>
          <Noc className='me-1' noc={home?.participant?.organisation?.code} /><Competitor {...home?.participant} hidePicture={true} alwaysNoc={true} />
        </div>
      </div>

      <div className="col-2">
        <div className='d-flex justify-content-center'>
          {isHomeCurrent
            ? <><FontAwesomeIcon icon={faCircle} /></>
            : ''
          } &nbsp;<strong>{gamesHome}-{gamesAway}</strong>&nbsp;
          {isAwayCurrent
            ? <><FontAwesomeIcon icon={faCircle} /></>
            : ''
          }

        </div>
      </div>

      <div className="col-5">
        <div className='d-flex justify-content-start'>
          <Noc className='me-1' noc={away?.participant?.organisation?.code} /><Competitor {...away?.participant} hidePicture={true} alwaysNoc={true} />
        </div>
      </div>
    </div>
      <br />
    </>

  )
}


